import React from "react";

const OutlineButton = ({
  label = "Add Additional Unit",
  icon = null,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex flex-row justify-center items-center gap-2 
        px-6 py-4 w-[183px] h-[36px]
        bg-[rgba(82,193,113,0.1)] border border-[#52C171] rounded-[12px] hover:bg-gray-100
        ${className}`}
    >
      <div className="flex flex-row justify-center items-center gap-2 w-[135px] h-[24px]">
        {icon && <span className="flex items-center">{icon}</span>}
        <span
          className="w-[135px] h-[24px] font-['Neue Haas Grotesk Display Pro']
          font-medium text-[16px] leading-[24px] tracking-[0.025em] text-[#52C171]"
        >
          {label}
        </span>
      </div>
    </button>
  );
};

export default OutlineButton;
